const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    position: 'relative',
    marginRight: theme.spacing(1),
  },
  icon: {
    position: 'absolute',
  },
  iconWarning: {
    color: theme.palette.warning.main,
  },
  iconSuccess: {
    color: theme.palette.success.main,
  },
})

export default styles
